<!--通用的可编辑列表-->
<template>
  <div class="custom-tab">
    <a-table
      :columns="columns"
      :dataSource="currentDataList"
      :pagination="false"
    >
      <template v-for="(col, i) in columnKeys" :slot="col" slot-scope="text,record,index">
        <slot v-if="virtualNames.includes(col)" :name="col" :text="text" :record="record" :index="index"></slot>
        <template v-else-if="record.editable">
          <a-input
            :key="col"
            v-model="record[col]"
            :disabled="record.isDisabled"
            :placeholder="columns[i].placeholder?columns[i].placeholder:columns[i].title"
          />
        </template>
        <template v-else>{{ text }}</template>
      </template>
      <template slot="operation" slot-scope="text, record,index">
        <slot v-if="customAction" :name="customAction" :text="text" :record="record" :index="index"></slot>
        <template v-else-if="record.editable">
            <span v-if="record.isNew">
              <a @click="saveRow(record,index)">保存</a>
              <a-divider v-if="deleteAndAdd" type="vertical"/>
              <a-popconfirm v-if="deleteAndAdd" title="是否要删除此行？" @confirm="removeRow(record.key)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          <span v-else>
              <a @click="saveRow(record,index)">保存</a>
              <a-divider type="vertical"/>
              <a @click="()=>record.editable=false">取消</a>
            </span>
        </template>
        <span v-else>
             <a v-if="!record.isDisabled" @click="()=>  record.editable = !record.editable">编辑</a>
              <a-divider v-if="deleteAndAdd" type="vertical"/>
              <a-popconfirm v-if="deleteAndAdd" title="是否要删除此行？" @confirm="removeRow(record.key,record)">
                <a>删除</a>
              </a-popconfirm>
          </span>
      </template>
    </a-table>
    <a-button
      v-if="editable && deleteAndAdd"
      style="width: 100%; margin-top: 16px; margin-bottom: 8px"
      type="dashed"
      icon="plus"
      @click="newMember()">添加
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'editorTable',

  props: {
    //标记是否启用编辑
    editable: {
      type: Boolean,
      default: true
    },
    //虚拟名字，辅助编辑填充数据（虚拟节点）
    virtualNames: {
      type: Array,
      default: function() {
        return []
      }
    },
    //忽略检查字段
    ignoreCheckNames: {
      type: Array,
      default: function() {
        return ['remarks']//默认忽略检查备注字段
      }
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    columnKeys: {
      type: Array,
      default: function() {
        return []
      }
    },
    //自定义操作
    customAction: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Array,
      default: function() {
        return []
      }
    },
    deleteAndAdd: {
      type: Boolean,
      default: true
    },
    beforeSave: {
      type: Function,
      default: undefined
    },
    beforeEditRecord: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      currentDataList: []
    }
  },

  watch: {
    dataSource: function(list) {
      this.currentDataList = this.transformEditTabDataList(list)
    }
  },
  mounted() {
    this.currentDataList = this.transformEditTabDataList(this.dataSource)
  },
  methods: {
    removeRow(key, record) {
      this.currentDataList = this.currentDataList.filter(item => item.key !== key)
    },
    editRecord(record, index) {
      record.editable = !record.editable
    },
    newMember() {
      let newItem = {
        key: this.getRowKey(this.currentDataList.length),
        editable: true,
        isNew: true
      }
      this.currentDataList.push(newItem)
    },
    saveRow(record, index) {
      let verificationSuccess = false
      if (this.beforeSave && typeof this.beforeSave === 'function') {
        verificationSuccess = this.beforeSave(record, index)
      } else {
        const ignoreCheckNames = [...this.ignoreCheckNames, ...this.virtualNames]
        const tips = this.verificationLineInputs(record, this.columns, this.columnKeys, ignoreCheckNames)
        if (tips) {
          this.$message.error(tips)
        } else {
          verificationSuccess = true
        }
      }
      if (verificationSuccess) {
        record.editable = false
        record.isNew = false
      }
    },
    /**
     * 获取当前table数据
     */
    getTableData() {
      let newList = [...this.currentDataList]
      return this.getTabSubmitData(newList)
    },
    getTabSubmitData(dataList, extra) {
      const list = []
      if (dataList && dataList.length > 0) {
        dataList.forEach((item, index, arr) => {
          if (!item.editable) {
            const newItem = { ...item, ...extra }
            delete newItem.editable
            delete newItem.isNew
            delete newItem.key
            list.push(newItem)
          }
        })
      }
      return list
    },
    //将数据源转化为编辑列表数据
    transformEditTabDataList(dataList) {
      const newList = []
      if (dataList && dataList.length > 0) {
        dataList.forEach((item, index, arr) => {
          newList.push({ ...item, key: this.getRowKey(index), editable: false, isNew: false, isDisabled: false })
        })
      }
      return newList
    },
    getRowKey(index) {
      let time = new Date().getTime()
      return time % 100000 + index
    },
    verificationLineInputs(inputItem, columnsDataList, keyList, ignoreKeys) {
      const verificationKeys = ignoreKeys ? keyList.filter(itemKey => !ignoreKeys.includes(itemKey)) : keyList// 要校验的输入字段
      for (let i = 0, len = verificationKeys.length; i < len; i++) {
        const currentKey = verificationKeys[i]
        if ((typeof inputItem[currentKey] === 'number' && inputItem[currentKey] < 0) || (typeof inputItem[currentKey] !== 'number' && !inputItem[currentKey])) {
          const name = this.getTipsName(currentKey, columnsDataList)
          return '请填写' + name + '信息。'
        }
      }
      return ''
    },
    getTipsName(key, columns) {
      if (key && columns && columns.length > 0) {
        for (let i = 0, len = columns.length; i < len; i++) {
          if (columns[i].key === key) {
            return columns[i].title
          }
        }
      }
      return ''
    }
  }

}
</script>
<style lang="less">
.custom-tab {
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
</style>